export default {
    PENDENTE: 'Pagamento pendente',
    PARCIALMENTE_PAGO: 'Parcialmente paga',
    PAGO: 'Pago',
    CANCELADA: 'Cancelada'
}